import { useState } from "react";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import { Badge, Button } from "react-bootstrap";
import RequestsService from "../../../../../services/RequestsService";
import { toast } from "react-toastify";
import PayLeaveParkingModal from "../PayLeaveParkingModal";

const CardItem = ({ item, index, setShouldUpdate, selectTab }) => {
	const [modal, setModal] = useState(false);
	const Auth = useSelector((state) => state.auth?.auth);
	const lang = useSelector((state) => state.auth?.lang);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);

	const readyForPickupFunction = () => {
		new RequestsService().readyForPickup(item?.id).then((res) => {
			if (res?.status) {
				toast.success("Car Ready For Pickup");
				setShouldUpdate((prev) => !prev);
			}
		});
	};

	return (
		<tr key={index} className="text-center">
			<td className="text-wrap-mode">{item.client_name}</td>
			<td>{item.client_phone}</td>
			<td className="text-wrap-mode">{item.entry_time?.split("T")[0]}</td>
			<td>
				{new Date(item.entry_time)?.toLocaleTimeString([], {
					hour: "2-digit",
					minute: "2-digit",
					hour12: false, // remove AM/PM
				})}
			</td>
			<td className="text-wrap-mode">
				{lang === "en" ? item.zone?.name_en : item.zone?.name_ar}
			</td>
			<td>{item.floor}</td>
			<td className="text-wrap-mode">
				{lang === "en"
					? item.parking_slot?.name_en
					: item.parking_slot?.name_ar}
			</td>
			<td className="text-wrap-mode">
				{Number(item.price).toFixed(3)} {Translate[lang].kwd}
			</td>
			<td>
				<Badge
					variant={`${
						item.status === "ready"
							? "success"
							: item.status === "leave"
							? "danger"
							: item.status === "pending"
							? "info"
							: item.status === "prepare_car"
							? "warning"
							: "secondary"
					} light`}>
					{Translate[lang][item?.status]}
				</Badge>
			</td>
			{selectTab === "requests" && (
				<td>
					<div className="d-flex" style={{ gap: "20px" }}>
						{item.status === "prepare_car" && (
							<Button
								variant="primary"
								className="text-wrap-mode"
								onClick={() => readyForPickupFunction()}>
								{Translate[lang].ready_for_pickup}
							</Button>
						)}
						{item.status === "ready" && (
							<Button
								variant="warning"
								className="text-wrap-mode"
								onClick={() => setModal(true)}>
								{Translate[lang].pay}
							</Button>
						)}
					</div>
				</td>
			)}

			{modal && (
				<PayLeaveParkingModal
					modal={modal}
					setModal={() => setModal(false)}
					item={item}
					setShouldUpdate={setShouldUpdate}
				/>
			)}
		</tr>
	);
};
export default CardItem;
